import { settings } from "@/settings"
import React from "react"

export default function RedirectToCalls(): React.JSX.Element {
  if (settings.SHOW_NATIVE_APP) {
    window.location.href = "/mobile"
  } else {
    window.location.href = "/dashboard"
  }

  return <></>
}
